import Image from 'semantic-ui-react/dist/commonjs/elements/Image';
import '@purple/semantic-ui-purple-theme/components/image.css';

export default Image;
